// extracted by mini-css-extract-plugin
export default {"photo":"MentorAvatar_photo__CoT1C","initials":"MentorAvatar_initials__oZw93"};